exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___3dHg9{border-radius:5px;overflow:hidden;height:80vh;width:100%}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___3dHg9"
};